export default __webpack_public_path__ + "static/media/Page_42.51def9d3.png";